<template>

    <CobaltDashboard :info="null" :company="null" :withFilterBar="false" contentClasses="single ps-0 pe-0" dashboardClasses="single">

        <div class="np-home">
            <div class="row h-100">
                <div class="d-flex flex-column h-100" :class="this.activeScreen == 'summary' ? 'col-lg-12' : 'col-lg-9' ">
                    <Summary 
                        v-if="this.activeScreen == 'summary'"
                        @switchScreen="switchScreen"
                    ></Summary>
                    <ProjectsAndSpaces 
                        v-if="this.activeScreen == 'projectAndSpaces'"
                        @switchScreen="switchScreen"
                    ></ProjectsAndSpaces>
                </div>

                <div class="col-lg-3 h-100 d-flex flex-column" v-if="this.activeScreen != 'summary'">
                    <Tabs modelValue="comments">
                        <Tab id="comments" :title="$t('UI.task.comments')" :icon="require('@/assets/images/icons/comment.svg') + '#icon'">                   
                            <div class="np-panel flex-grow-1">
                                <div class="np-group np-group-column np-comments">
                                    <PerfectScrollbar>
                                        <ul class="np-list">
                                            <li class="np-comment" v-for="item in commentsList" :key="item.id">
                                                <div class="np-group justify-content-between np-mb-3 w-100">
                                                    <div class="np-badge-s np-inactive np-font-xs np-mr-2">Задача</div>
                                                    <button class="np-btn np-btn-link"><svg><use href="@/assets/images/icons/eye.svg#icon"></use></svg></button>
                                                </div>
                                                <div class="np-group align-items-center">
                                                    <CobaltProfile 
                                                        :firstName="item.user.first_name" 
                                                        :lastName="item.user.last_name" 
                                                        :avatar="item.user.imageFile"
                                                        size="np-avatar-medium me-1"
                                                        :short="true"
                                                    />
                                                    <div class="np-group np-group-column">
                                                        <span class="np-font-m np-f-medium">{{ item.user?.first_name }}</span>
                                                        <span class="np-font-xs np-color-light">{{ localeDateTime(item.date_create) }}</span>
                                                    </div>
                                                </div>
                                                <div class="np-comment-text">
                                                    {{ item.body }}
                                                </div>
                                                <div class="np-group justify-content-between">
                                                    <div class="np-group align-items-center" v-if="item.reply">
                                                        <svg class="np-mr-1"><use href="@/assets/images/icons/comment.svg#icon"></use></svg>
                                                    </div>                                            
                                                </div>
                                            </li>
                                        </ul>  
                                    </PerfectScrollbar>                              
                                </div>
                            </div>                    
                        </Tab>
                        <Tab id="notifications" :title="$t('UI.dashboard.notifications')" :icon="require('@/assets/images/icons/notification.svg') + '#icon'">
                            <div class="np-panel flex-grow-1">
                                <div class="np-group np-group-column np-comments">
                                    <PerfectScrollbar>
                                        <ul class="np-list">
                                            <li class="np-comment" v-for="item in notificationStore.notifications" :key="item.id">
                                                <div class="np-group align-items-center">
                                                    <div class="np-group">
                                                        <span class="np-font-xs me-2 np-color-light">{{ localeDateTime(item.created_at) }}</span>
                                                        <span class="np-font-xs">{{ item.model_name }}</span>
                                                    </div>
                                                </div>
                                                <div class="np-font-s">
                                                    <span :class="item.is_read ? 'np-color-light' : 'np-f-bold'">{{ item.message }}</span>
                                                </div>
                                            </li>
                                        </ul>  
                                    </PerfectScrollbar>                              
                                </div>
                            </div> 
                        </Tab>
                    </Tabs>
                </div> 
            </div> 
        </div>
    
    </CobaltDashboard>

    <BssModal :modalID='modalID' ref="BssModal" class="cobalt-base-dialog">
        <template v-slot:header-left>{{ $t("UI.addCompany") }}</template>
        <template v-slot:body>
            <div class="modal-body">
                <form>
                    <div class="mb-3">
                        <label for="spaceTitle">{{ $t("UI.name") }}:</label>
                        <input type="text" class="form-control-log" id="spaceTitle" aria-describedby="loginHelp"
                            v-model="datComp.title">
                        <small id="loginHelp" class="form-text text-muted"></small>
                    </div>
                    <div class="mb-4">
                        <label for="spaceDescription">{{ $t("UI.description") }}:</label>
                        <textarea class="form-control-log" id="spaceDescription"
                            v-model="datComp.description"></textarea>
                    </div>

                    <div v-if="datComp.errorText != ''">
                        <p class="mt-2 mb-0 text-danger">{{ datComp.errorText }}</p>
                    </div>
                </form>
            </div>
            <div class="modal-footer p-1">
                <button type="button" class="btn btn-outline-secondary btn-sm me-1"
                    data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
                <button type="button" class="btn btn-secondary btn-sm" @click="addCompanyM">{{ $t("UI.add") }}</button>
            </div>
        </template>
    </BssModal>

    <ProjectModal 
        modalID="modalProjectNewID"
        @refresh="refresh"
        ref="projectModal" 
    />    
</template>

<script>
import { useSettingsStore } from '@/stores/settingsStore.js'
import { useNotificationStore } from "@/stores/notificationStore"

import BssModal from "@/components/modals/BsModal.vue"
import ProjectModal from "@/components/modals/ProjectModal.vue"
import CobaltDashboard from "@/components/dashboard/CobaltDashboard.vue"
import CobaltProfile   from "@/components/dashboard/parts/CobaltProfile.vue"
import Summary from "@/components/dashboard/home/Summary.vue"
import ProjectsAndSpaces from "@/components/dashboard/home/ProjectsAndSpaces.vue"
import Tabs from "@/components/elements/tabs/Tabs.vue"
import Tab from "@/components/elements/tabs/Tab.vue"
import { localeDate, localeDateTime, formatBytes } from '@/utils/format'

import { mapGetters, mapActions } from 'vuex'
import { DatePicker } from "qalendar"
import Config from '../config.js'
import "qalendar/dist/style.css"

export default {
    components: {
        BssModal,
        ProjectModal,
        CobaltDashboard,
        CobaltProfile,
        Summary,
        ProjectsAndSpaces,
        DatePicker,
        Tabs, Tab
    },
    data() {
        return {
            Config,
            activeScreen: "summary",
            spacesList: [],
            commentsList: [],
            modalID: 'NewModCompNULP',
            modalDel: 'modalDelete',
            datComp: {
                id: 0,
                title: '',
                description: '',
                errorText: '',
            },            
            compInf: null,
            projectsInfo: [],
            messages: [],
            selectedSpaceId: 0,
            selectedProject: null,
            projectsVisible: false,
            projectsLoading: false,
            wActiveTab: 'wComments'
        }
    },
    async beforeMount() {
        this.getListSpaces()
        this.getUserComments()
        await this.notificationStore?.init()        
    },
    computed: {
        notificationStore() {
            return useNotificationStore()
        }        
    },
    methods: {
        ...mapActions('dashboard', ['listComments']),
        ...mapGetters('dashboard', ['getListComments']), 
        ...mapActions('company', ['info', 'list', 'addCompany', 'delete']),
        ...mapGetters('company', { getInfo: 'getInfo', companyList: 'getList'}),
        ...mapActions('project', { projectsList: 'list', addProject: 'saveProject', projectDelete: 'delete' }),
        ...mapGetters('project', { getProjectsList: 'getList' }),
        localeDateTime,

        switchScreen(target) {
            this.activeScreen = target
        },
        async getListSpaces() {
            await this.list([600, 400])
            this.spacesList = this.companyList()
        },
        async getUserComments() {
            await this.listComments()
            this.commentsList = this.getListComments().comments
        },        
        newCompany() {
            this.$refs.BssModal.shows()
        },
        async addCompanyM() {
            const result = await this.addCompany(this.datComp)
            await this.list([600, 400])
            this.$refs.BssModal.hide()

            if (result) {
                this.selectedSpaceId = result.id
            }

            this.refresh()
        },
        async deleteCompany() {
            await this.delete(this.selectedID)
            this.$refs.DelCompanyModalRef.hide()
            this.getListComp()
        },
        async switchSpace(spaceId) {
            this.projectsVisible = true
            this.projectsLoading = true

            this.selectedSpaceId = spaceId

            await this.refresh()

            this.projectsLoading = false
        },
        closeProjects() {
            this.projectsVisible = false
            this.projectsInfo = []
            this.selectedProject = null
        },
        setWidgetActiveTab(tab) {
          this.wActiveTab = tab
        }, 
        newProject() {
            this.$refs.projectModal.shows(this.selectedSpaceId, {});
        },        
        requestProjectEdit(event, project) {
            event.stopPropagation();
            event.preventDefault();

            this.selectedProject = { ... project }

            this.$refs.projectModal.shows(this.selectedSpaceId, this.selectedProject)
        },          
        async refresh() {
            let dataParam = {
                pic_h: 400,
                pic_w: 600,
                company_id: this.selectedSpaceId
            }            

            await this.projectsList(dataParam)
            this.projectsInfo = this.getProjectsList()            
        }         
    }

}
</script>

<style>
    .home {
        width: 100%;
        height: 100%;
    }
    .welcome-block {
        position: relative;
        display: flex;
        align-items: center;        
        border-radius: 8px;
        color: #FFF;
        background-image: url("../../src/assets/images/dashboard/home/bg.png") no-repeat right top;        
        margin-top: 35px;
    }
    .welcome-block img {
        margin-top: -25px;
    }
    .welcome-panel {
        background-color: #e8f2fd;
        border-radius: 8px;
        margin-top: 25px;
        padding: 15px;
    }
    .welcome-panel.transparent {
        background-color: transparent;
    }
    .welcome-panel__header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
    }
    .welcome-panel__header-header {
        font-weight: 600;
        font-size: 18px;
    }    
    .date-picker.date-picker-root {
        width: auto;
    } 
    .date-picker .week span {
        border-radius: 8px;
    }    
    .date-picker.date-picker-root .week span.is-weekend {
        color: #F44336;
    }    
    .date-picker-root .date-picker__week-picker:not(.is-light-mode .date-picker__week-picker) {
        background-color: #ffffff;
        border-color: transparent;
        box-shadow: none;
        padding: 0;
    }
    .date-picker__week-picker-navigation {
        font-weight: 500 !important;
        text-transform: uppercase;
        border-bottom: 1px solid #ededed;
        padding: 20px 0;
        position: relative;
    }
    .date-picker__toggle-mode {
        position: absolute;
        left: 0;
    }
    svg.svg-inline--fa.fa-circle-chevron-left.is-icon.is-chevron-left {
        position: absolute;
        right: 32px;
    }
    svg.svg-inline--fa.fa-circle-chevron-right.is-icon.is-chevron-right {
        position: absolute;
        right: 0;
    }  
    .date-picker .week span {
        border-radius: 10px !important;
    }    
    .progress-bar {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: 
            radial-gradient(closest-side, #e8f2fd 92%, transparent 95% 100%),
            conic-gradient(rgb(34,193,195) 75%, rgb(255, 255, 255) 0);    
    }
    .progress-bar::before {
        content: "75%";
    }
    .single-project,
    .single-activity {
        display: flex;
        border: 1px solid #c9d9e9;
        border-radius: 8px;
        margin-bottom: 10px;
        padding: 10px 20px;
        align-items: center;
    }  
    .single-project__name {
        padding-left: 15px;
        flex:1;
    }   
    .single-project__name h3 {
        margin: 0;
        font-size: 16px;
    }
    .days-left {
        padding: 7px 15px;
        background-color: #1b7280;
        color: #FFF;
        border-radius: 8px;
        font-size: 12px;
    }
    .single-activity {
        background-color: #e8f2fd;
        border: none;
    }
    .single-activity__name h3 {
        padding-top: 5px;
        font-size: 16px;
        font-weight: 600;
    }
    .single-activity__name span {
        font-size: 14px;
    }
    .dashboard-active-panel {
        border: 1px solid #dfe9f3;
        border-radius: 8px;
        padding: 20px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }   

    .vs__open-indicator {
        width: auto;
        height: auto;
    }
    .v-select {
        position: relative;
        font-family: inherit;
        min-width: 145px;
    }
</style>